/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * This function imports modules from CDN https://developers.arcgis.com/javascript/latest/programming-patterns/#set-the-portalurl-in-an-amd-application
 * For what is available for import see https://developers.arcgis.com/javascript/latest/api-reference/
 * @param path
 */
export function arcgisImport(path) {
    return globalThis.$arcgis.import(path);
}
